import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { ROUTES } from 'routes/routes';
import { LeagueLogoImg } from './Header.style';
import Footer from 'components/Footer';
import LeagueLogo from '../../assets/logo/orlen-liga-wspinaczkowa-dark.svg';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';

const Header: React.FC = () => {
  const [offcanvasShow, setOffcanvasShow] = useState(false);

  const showOffcanvas = () => setOffcanvasShow(true);

  const hideOffcanvas = () => setOffcanvasShow(false);

  return (
    <>
      <Navbar expand="md" className="navbar-dark bg-dark">
        <Container>
          <Navbar.Brand as={NavLink} to={ROUTES.HOME}>
            <LeagueLogoImg
              src={LeagueLogo}
              alt="ORLEN Liga Wspinaczkowa"
              height={84}
              width={91}
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="offcanvasNavbar-expand-md"
            onClick={showOffcanvas}
          />
          <Navbar.Offcanvas
            id="offcanvasNavbar-expand-md"
            aria-labelledby="offcanvasNavbarLabel-expand-md"
            placement="end"
            show={offcanvasShow}
            onHide={hideOffcanvas}
          >
            <Offcanvas.Header closeButton>
              <Offcanvas.Title id="offcanvasNavbarLabel-expand-md">
                &nbsp;
              </Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <Nav className="justify-content-start flex-grow-1 pe-3">
                <Nav.Link
                  as={NavLink}
                  to={ROUTES.LEAGUE}
                  onClick={hideOffcanvas}
                >
                  Liga
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to={ROUTES.MATCHES}
                  onClick={hideOffcanvas}
                >
                  Mecze
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to={ROUTES.TEAMS}
                  onClick={hideOffcanvas}
                >
                  Drużyny
                </Nav.Link>
                <Nav.Link
                  as={NavLink}
                  to={ROUTES.CONTACT}
                  onClick={hideOffcanvas}
                >
                  Kontakt
                </Nav.Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
        </Container>
      </Navbar>

      <Outlet />

      <Footer />
    </>
  );
};

export default Header;
